<template>
  <div class="forms-elements print-temp">
    <div class="vertical-sidenav sidenav-container-layout">
      <!-- Sidenav for Print Template -->
      <div class="sidenav">
        <b-nav
          vertical
          class="side-nav-content custom-print-sidenav"
          style="width: 400px !important;"
        >
          <div class="sidenav-container-layout">
            <div>
              <!-- options -->
              <b-tabs v-model="tabIndex" class="nav-cols custom-line-tab border-tab mt-2">
                <!-- Template Tab -->
                <b-tab title="Template" class="px-pad py-3 mt-2 mr-4">
                  <b-form data-vv-scope="temp_prop_tab">
                    <b-row class="ml-1">
                      <b-col class="px-0">
                        <!-- Template Name -->
                        <b-form-group
                          :label="'Template Name'"
                          label-class="required"
                          label-for="temp_name"
                          class="mb-4"
                        >
                          <b-form-input
                            disabled
                            name="temp_name"
                            :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.temp_name')}"
                            v-validate="'required|max:50'"
                            v-model="temp_prop.temp_name"
                          />
                        </b-form-group>
                        <!-- Paper Size -->
                        <b-form-group
                          horizontal
                          label="Paper Size"
                          label-for="paper_size"
                          class="mb-4"
                        >
                          <b-form-radio-group
                            class="mt-1"
                            v-model="temp_prop.paper_size"
                            :options="papersize"
                          />
                        </b-form-group>
                        <!-- Orientation -->
                        <b-form-group
                          horizontal
                          label="Orientation"
                          label-for="orientation"
                          class="mb-4"
                        >
                          <b-form-radio-group
                            class="mt-1"
                            v-model="temp_prop.orientation"
                            :options="orientation"
                          />
                        </b-form-group>
                        <!-- Margins -->
                        <b-form-group
                          label="Margins (in Inches)"
                          label-class="required"
                          label-for="margins"
                          class="mb-4"
                        >
                          <div style="display:inline-flex">
                            <!-- Margin Top -->
                            <b-col sm="3" class="pl-0 pr-2">
                              <b-form-input
                                name="margin_top"
                                :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.margin_top')}"
                                v-validate="'min_value:0'"
                                v-model="temp_prop.margin_top"
                              />
                              <small class="text-muted">Top</small>
                            </b-col>
                            <!-- Margin bottom -->
                            <b-col sm="3" class="pl-0 pr-2">
                              <b-form-input
                                name="margin_bottom"
                                :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.margin_bottom')}"
                                v-validate="'min_value:0'"
                                v-model="temp_prop.margin_bottom"
                              />
                              <small class="text-muted">Bottom</small>
                            </b-col>
                            <!--Margin left  -->
                            <b-col sm="3" class="pl-0 pr-2">
                              <b-form-input
                                name="margin_left"
                                :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.margin_left')}"
                                v-validate="'min_value:0'"
                                v-model="temp_prop.margin_left"
                              />
                              <small class="text-muted">Left</small>
                            </b-col>
                            <!-- Margin right -->
                            <b-col sm="3" class="pl-0 pr-0">
                              <b-form-input
                                name="margin_right"
                                :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.margin_right')}"
                                v-validate="'min_value:0'"
                                v-model="temp_prop.margin_right"
                              />
                              <small class="text-muted">Right</small>
                            </b-col>
                          </div>
                        </b-form-group>
                          <b-form-group
                          horizontal
                          label="Font Size"
                          label-for="temp_font_size"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group append="pt">
                            <b-form-input
                              name="temp_font_size"
                              :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.temp_font_size')}"
                              v-validate="'min_value:0|max_value:18'"
                              v-model="temp_prop.font_size"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        
                           <b-form-group
                          class="mb-4"
                          horizontal
                          label="Font Color"
                          label-for="temp_font_color"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              :value="temp_prop.temp_font_color.hex"
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_12 }"
                              v-model="temp_prop.temp_font_color"
                            />
                            <b-input-group-text
                              @click="colorPickerActive.color_12 = !colorPickerActive.color_12"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': temp_prop.temp_font_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                            <b-form-group
                          class="mb-4"
                          horizontal
                          label="Label Color"
                          label-for="temp_label_color"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              :value="temp_prop.temp_label_color.hex"
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_10 }"
                              v-model="temp_prop.temp_label_color"
                            />
                            <b-input-group-text
                              @click="colorPickerActive.color_10 = !colorPickerActive.color_10"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': temp_prop.temp_label_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                             <b-form-group
                          class="pb-1 mb-4"
                          label="Background Color"
                          label-for="temp_bg_color"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <div class="abc-checkbox" style="padding-top:5px;">
                              <input
                                type="checkbox"
                                id="head_bg_color"
                                :true-value="1"
                                :false-value="0"
                                v-model="temp_prop.is_temp_bg_color"
                              />
                              <label for="head_bg_color"></label>
                            </div>
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              :value="temp_prop.temp_bg_color.hex"
                            />

                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_11 }"
                              v-model="temp_prop.temp_bg_color"
                            />

                            <b-input-group-text
                              @click="colorPickerActive.color_11=!colorPickerActive.color_11"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': temp_prop.temp_bg_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-tab>
                <!-- Header Tab -->
                <b-tab title="Header" class="px-pad py-3 mt-2 mr-4">
                  <b-form data-vv-scope="header_prop_tab">
                    <b-row class="ml-1">
                      <b-col class="px-0">
                        <!-- Showing Organization Logo -->
                        <b-form-group class="mb-4">
                          <div class="abc-checkbox">
                            <input
                              type="checkbox"
                              id="org_logo_show"
                              :true-value="1"
                              :false-value="0"
                              v-model="header_prop.show_logo"
                            />
                            <label
                              for="org_logo_show"
                              style="padding-top:2px;"
                            >Showing Organization Logo</label>
                          </div>
                        </b-form-group>
                        <!-- resize logo -->
                        <b-form-group
                          class="mb-4"
                          v-if="header_prop.show_logo==1"
                          label="Resize Logo"
                          horizontal
                          label-for="resize_logo"
                          :label-cols="4"
                        >
                          <b-form-slider
                            @change="findHieght($event)"
                            v-model="header_prop.logo_width"
                            :value="150"
                            :max="300"
                            :min="50"
                          />
                        </b-form-group>
                        <!-- Show Organization Name -->
                        <b-form-group class="mb-4">
                          <div class="abc-checkbox">
                            <input
                              type="checkbox"
                              id="org_name_show"
                              :true-value="1"
                              :false-value="0"
                              v-model="header_prop.show_org_name"
                            />
                            <label
                              for="org_name_show"
                              style="padding-top:2px;"
                            >Show Organization Name</label>
                          </div>
                        </b-form-group>
                        <!-- Show Organization Address -->
                        <b-form-group class="mb-4">
                          <div class="abc-checkbox">
                            <input
                              type="checkbox"
                              id="org_addr_show"
                              :true-value="1"
                              :false-value="0"
                              v-model="header_prop.show_org_addr"
                            />
                            <label
                              for="org_addr_show"
                              style="padding-top:2px;"
                            >Show Organization Address</label>
                          </div>
                        </b-form-group>
                        <!-- Show Document Title -->
                        <b-form-group class="mb-4">
                          <div class="abc-checkbox">
                            <input
                              disabled
                              type="checkbox"
                              id="doc_title_show"
                              :true-value="1"
                              :false-value="0"
                              v-model="header_prop.show_doc_title"
                            />
                            <label for="doc_title_show" style="padding-top:2px;">Show Document Title</label>
                          </div>
                        </b-form-group>
                        <!-- Document Title Label -->
                        <b-form-group class="mb-4">
                          <b-form-input
                            v-model="header_prop.doc_title"
                            name="doc_title_label"
                            v-validate="'max:50'"
                            :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_title_label')}"
                          ></b-form-input>
                        </b-form-group>
                        <!-- Header Background -->
                        <b-form-group
                          class="pb-1 mb-4"
                          label="Background Color"
                          label-for="head_bg_color"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <div class="abc-checkbox" style="padding-top:5px;">
                              <input
                                type="checkbox"
                                id="head_bg_color"
                                :true-value="1"
                                :false-value="0"
                                v-model="header_prop.is_header_bg_color"
                              />
                              <label for="head_bg_color"></label>
                            </div>
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              :value="header_prop.header_bg_color.hex"
                            />

                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_1 }"
                              v-model="header_prop.header_bg_color"
                            />

                            <b-input-group-text
                              @click="colorPickerActive.color_1=!colorPickerActive.color_1"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': header_prop.header_bg_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <!-- Document Details -->
                    <b-row class="my-2 ml-0">
                      <b-col class="px-0">
                        <h6 class="mb-3 h6-lg text-link">Document Title</h6>
                        <!-- Document Title Font Size -->
                        <b-form-group
                          horizontal
                          label="Font Size"
                          label-for="doc_title_size"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group append="pt">
                            <b-form-input
                              name="doc_font_size"
                              :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_font_size')}"
                              v-validate="'min_value:0|max_value:18'"
                              v-model="header_prop.doc_title_size"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <!-- Document Title Font Color -->
                        <b-form-group
                          class="mb-4"
                          horizontal
                          label="Font Color"
                          label-for="doc_title_color"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              :value="header_prop.doc_title_color.hex"
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_2 }"
                              v-model="header_prop.doc_title_color"
                            />
                            <b-input-group-text
                              @click="colorPickerActive.color_2 = !colorPickerActive.color_2"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': header_prop.doc_title_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <!-- Organization Details -->
                    <b-row class="my-2 ml-0">
                      <b-col class="px-0">
                        <h6 class="mb-3 h6-lg text-link">Organization</h6>

                        <!-- Organization Name Color -->
                        <b-form-group
                          horizontal
                          label="Name Color"
                          label-for="org_name_color"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <input
                              type="text"
                              class="form-control"
                              :value="header_prop.org_name_color.hex"
                              disabled
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_3 }"
                              v-model="header_prop.org_name_color"
                            />
                            <b-input-group-text
                              style="padding:5px !important;"
                              @click="colorPickerActive.color_3 = !colorPickerActive.color_3"
                              slot="append"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': header_prop.org_name_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>

                        <!-- Organization Name Size -->
                        <b-form-group
                          horizontal
                          label="Name Size"
                          label-for="name_size"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group append="pt">
                            <b-form-input
                              name="org_name_size"
                              :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.org_name_size')}"
                              v-validate="'min_value:0|max_value:18'"
                              v-model="header_prop.org_name_size"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <!-- Organization Phone -->
                        <b-form-group
                          horizontal
                          label="Phone"
                          label-for="phone"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-form-input
                            name="org_phone_no"
                            :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.org_phone_no')}"
                            v-validate="'max:50'"
                            v-model="header_prop.phone"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!-- Customer Name Details -->
                    <b-row class="my-2 ml-0">
                      <b-col class="px-0">
                        <h6 class="mb-3 h6-lg text-link">Customer Name</h6>

                        <!-- Customer Name Color -->
                        <b-form-group
                          horizontal
                          label="Font Color"
                          label-for="cus_name_color"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <input
                              type="text"
                              class="form-control"
                              :value="header_prop.cus_name_color.hex"
                              disabled
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_4 }"
                              v-model="header_prop.cus_name_color"
                            />
                            <b-input-group-text
                              style="padding:5px !important;"
                              @click="colorPickerActive.color_4 = !colorPickerActive.color_4"
                              slot="append"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': header_prop.cus_name_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>

                        <!-- Customer name font -->
                        <b-form-group
                          horizontal
                          label="Font Size"
                          label-for="cus_name_size"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group append="pt">
                            <b-form-input
                              name="cus_name_font_size"
                              :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.cus_name_font_size')}"
                              v-validate="'min_value:0|max_value:18'"
                              v-model="header_prop.cus_name_size"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!-- Document Information -->
                    <b-row class="my-2 ml-0">
                      <b-col class="px-0">
                        <h6 class="mb-3 h6-lg text-link">Document Information</h6>

                        <!-- Bill To Filed -->
                        <b-row class="pb-2">
                          <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                            <!-- Show Bill To  -->
                            <div class="abc-checkbox">
                              <input
                                type="checkbox"
                                id="doc_bill_to"
                                :true-value="1"
                                :false-value="0"
                                v-model="header_prop.doc_bill_to.show"
                              />
                              <label for="doc_bill_to" style="padding-top:2px;">Bill To</label>
                            </div>
                          </b-col>
                          <b-col sm="7" style="padding-left:7px">
                            <!-- Bill To Label -->
                            <b-form-input
                              name="doc_bill_to_label"
                              :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_bill_to_label')}"
                              v-validate="'max:50'"
                              :disabled="header_prop.doc_bill_to.show==0"
                              v-model="header_prop.doc_bill_to.label"
                            ></b-form-input>
                          </b-col>
                        </b-row>
                        <b-row class="pb-2">
                          <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                            <!-- Show Bill To  -->
                            <div class="abc-checkbox">
                              <input
                                type="checkbox"
                                id="doc_ref_no"
                                :true-value="1"
                                :false-value="0"
                                v-model="header_prop.doc_ref_no.show"
                              />
                              <label for="doc_ref_no" style="padding-top:2px;">Reference</label>
                            </div>
                          </b-col>
                          <b-col sm="7" style="padding-left:7px">
                            <!-- Bill To Label -->
                            <b-form-input
                              name="doc_ref_no_label"
                              :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_ref_no_label')}"
                              v-validate="'max:50'"
                              :disabled="header_prop.doc_ref_no.show==0"
                              v-model="header_prop.doc_ref_no.label"
                            ></b-form-input>
                          </b-col>
                        </b-row>
                        <!-- Show Total Account Summary-->
                        <b-form-group class="mt-4 mb-4">
                          <div class="abc-checkbox">
                            <input
                              type="checkbox"
                              id="account_summary"
                              :true-value="1"
                              :false-value="0"
                              v-model="header_prop.show_acc_sum"
                            />
                            <label
                              for="account_summary"
                              style="padding-top:2px;"
                            >Total Account Summary</label>
                          </div>
                        </b-form-group>
                        <b-form-group class="mb-4">
                          <b-form-input
                            :disabled="header_prop.show_acc_sum==0"
                            v-model="header_prop.total_sum_label"
                            name="total_sum_label"
                            v-validate="'max:50'"
                            :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.total_sum_label')}"
                          ></b-form-input>
                        </b-form-group>
                        <div v-if="header_prop.show_acc_sum">
                          <!-- Opening Balance Filed -->
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Opening Balance  -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="open_bal"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.open_bal.show"
                                />
                                <label for="open_bal" style="padding-top:2px;">Opening Balance</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left:7px !important">
                              <!-- Opening Balance Label -->
                              <b-form-input
                                name="open_bal_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.open_bal_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.open_bal.show==0"
                                v-model="header_prop.open_bal.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Invoiced Amount  -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="inv_amt"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.inv_amt.show"
                                />
                                <label for="inv_amt" style="padding-top:2px;">Invoiced Amount</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left:7px !important">
                              <!-- Invoiced Amount Label -->
                              <b-form-input
                                name="inv_amt_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.inv_amt_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.inv_amt.show==0"
                                v-model="header_prop.inv_amt.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Paid Amount  -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="paid_amt"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.paid_amt.show"
                                />
                                <label for="paid_amt" style="padding-top:2px;">Paid Amount</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left:7px !important">
                              <!-- Paid Amount Label -->
                              <b-form-input
                                name="paid_amt_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.paid_amt_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.paid_amt.show==0"
                                v-model="header_prop.paid_amt.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Balance Due  -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="acc_bal_due"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.bal_due.show"
                                />
                                <label for="acc_bal_due" style="padding-top:2px;">Balance Due</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left:7px !important">
                              <!-- Balance Due Label -->
                              <b-form-input
                                name="bal_due_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.bal_due_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.bal_due.show==0"
                                v-model="header_prop.bal_due.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-tab>
                <!-- Statement Properties -->
                <b-tab title="Statement" class="px-pad py-3 mt-2 mr-4">
                  <b-row class="ml-0">
                    <b-tabs
                      v-model="itemTabIndex"
                      class="nav-cols custom-line-tab button-nav button-tab"
                    >
                      <!-- Label Tab -->
                      <b-tab title="Labels" class="px-0">
                        <b-form data-vv-scope="item_label_prop_tab">
                          <!-- Date Field -->
                          <b-row class="pb-2 mt-4">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Date  -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="itm_date"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.date.show"
                                />
                                <label for="itm_date" style="padding-top:2px;">Date</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left:7px !important">
                              <!-- Date Label -->
                              <b-form-input
                                name="itm_date_label"
                                :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.itm_date_label')}"
                                v-validate="'max:50'"
                                :disabled="item_prop.label.date.show==0"
                                v-model="item_prop.label.date.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- transaction Field -->
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show transaction  -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="itm_trans"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.transaction.show"
                                />
                                <label for="itm_trans" style="padding-top:2px ;">Transactions</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left:7px">
                              <!-- transaction Label -->
                              <b-form-input
                                name="itm_trans_label"
                                :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.itm_trans_label')}"
                                v-validate="'max:50'"
                                :disabled="item_prop.label.transaction.show==0"
                                v-model="item_prop.label.transaction.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Details Field -->
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px;">
                              <!-- Show Details  -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="itm_detail"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.detail.show"
                                />
                                <label for="itm_detail" style="padding-top:2px;">Details</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left:7px !important">
                              <!-- Details Label -->
                              <b-form-input
                                name="itm_detail_label"
                                :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.itm_detail_label')}"
                                v-validate="'max:50'"
                                :disabled="item_prop.label.detail.show==0"
                                v-model="item_prop.label.detail.label"
                              ></b-form-input>
                               <small>
                                    <div class="abc-checkbox pt-2">
                                      <input
                                        type="checkbox"
                                        plain
                                        id="pjt"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="item_prop.label.pjt.show_pjt"
                                        :disabled="item_prop.label.pjt.show==0"
                                      />
                                      <label for="pjt" style="padding-top:2px;"  v-b-tooltip
                                       title="The project name will be displayed along with the details of invoices created from project">Show Project</label>
                                    </div>
                               </small>
                            </b-col>
                          </b-row>
                          <!-- Amount Field -->
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Amount  -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="itm_amt"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.amt.show"
                                />
                                <label for="itm_amt" style="padding-top:2px;">Amount</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left:7px !important">
                              <!-- Amount Label -->
                              <b-form-input
                                name="itm_amt_label"
                                :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.itm_amt_label')}"
                                v-validate="'max:50'"
                                :disabled="item_prop.label.amt.show==0"
                                v-model="item_prop.label.amt.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Payments Field -->
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Payments  -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="itm_payments"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.payments.show"
                                />
                                <label for="itm_payments" style="padding-top:2px;">Payments</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left:7px !important">
                              <!-- Payments Label -->
                              <b-form-input
                                name="itm_payments_label"
                                :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.itm_detail_label')}"
                                v-validate="'max:50'"
                                :disabled="item_prop.label.payments.show==0"
                                v-model="item_prop.label.payments.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Balance Field -->
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Balance  -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="itm_bal"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.bal.show"
                                />
                                <label for="itm_bal" style="padding-top:2px;">Balance</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left:7px !important">
                              <!-- Balance Label -->
                              <b-form-input
                                name="itm_bal_label"
                                :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.itm_bal_label')}"
                                v-validate="'max:50'"
                                :disabled="item_prop.label.bal.show==0"
                                v-model="item_prop.label.bal.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                           <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px;">
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="itm_refund"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.refund.show"
                                />
                                <label for="itm_refund" style="padding-top:2px;">Refund</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left:7px !important">
                              <b-form-input
                                name="itm_detail_label"
                                :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.itm_detail_label')}"
                                v-validate="'max:50'"
                                :disabled="item_prop.label.refund.show==0"
                                v-model="item_prop.label.refund.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                        </b-form>
                      </b-tab>
                      <!-- Layout Tab -->
                      <b-tab title="Layout">
                        <!-- Table Border -->
                        <b-form data-vv-scope="item_layout_prop_tab">
                          <!-- Table Header Fields -->
                          <b-row class="mb-2 mt-4 ml-0">
                            <b-col class="px-0">
                              <h6 class="mb-3 h6-lg text-link">Table Header</h6>
                              <!-- Table Header Font Size -->
                              <b-form-group
                                class="mb-4"
                                label="Font Size"
                                horizontal
                                label-for="tbl_hdr_size"
                                :label-cols="5"
                              >
                                <b-input-group append="pt">
                                  <b-form-input
                                    name="tbl_hdr_size"
                                    :class="{'is-invalid':item_layout_has_error&&errors.has('item_layout_prop_tab.tbl_hdr_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="item_prop.layout.header_font_size"
                                  ></b-form-input>
                                </b-input-group>
                              </b-form-group>
                              <!-- Table Header Background color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Background Color"
                                label-for="tbl_hdr_bg"
                                :label-cols="5"
                              >
                                <b-input-group class="colorpicker-wrapper">
                                  <!-- Show Field -->
                                  <div class="abc-checkbox" style="padding-top:5px;">
                                    <input
                                      type="checkbox"
                                      id="tbl_hdr_bg_color"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="item_prop.layout.bg_color.show"
                                    />
                                    <label for="tbl_hdr_bg_color"></label>
                                  </div>
                                  <!-- Color Picker -->
                                  <input
                                    type="text"
                                    class="form-control"
                                    disabled
                                    :value="item_prop.layout.bg_color.value.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_5 }"
                                    v-model="item_prop.layout.bg_color.value"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_5 = !colorPickerActive.color_5"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.bg_color.value.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                              <!-- Table Header font Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="tbl_hdr_font_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="item_prop.layout.header_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_6 }"
                                    v-model="item_prop.layout.header_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_6 = !colorPickerActive.color_6"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.header_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <!-- Statement Table Row Fields -->
                          <b-row
                            class="my-2 ml-0"
                            :style="{'margin-bottom':colorPickerActive.color_8?'310px':colorPickerActive.color_7?'280px':colorPickerActive.color_6?'200px':colorPickerActive.color_5?'150px':'unset'}"
                          >
                            <b-col class="px-0">
                              <h6 class="mb-3 h6-lg text-link">Statement Table Row</h6>
                              <!-- Statement Table Row Font Size -->

                              <!-- Item Description Font Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Odd Row Color"
                                label-for="desc_bg_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="item_prop.layout.odd_row.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_7 }"
                                    v-model="item_prop.layout.odd_row"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_7  = !colorPickerActive.color_7 "
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.odd_row.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Even Row Color"
                                label-for="desc_bg_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="item_prop.layout.even_row.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_8 }"
                                    v-model="item_prop.layout.even_row"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_8  = !colorPickerActive.color_8 "
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.even_row.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-form>
                      </b-tab>
                    </b-tabs>
                  </b-row>
                </b-tab>

                <!-- Footer Tab -->
                <b-tab title="Footer" class="px-pad py-3 mt-2 mr-4">
                  <!-- Notes Details -->
                  <b-form data-vv-scope="footer_prop_tab">
                    <!-- Footer Details -->
                    <b-row class="mb-2 ml-0">
                      <b-col class="px-0" style="padding-top: 7px !important;">
                        <h6 class="mb-3 h6-lg text-link">Footer</h6>
                        <!-- Footer Backgroud Color -->
                        <b-form-group
                          class="mb-4"
                          horizontal
                          label="Background Color"
                          label-for="footer_bg"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <!-- Apply Background -->
                            <div class="abc-checkbox" style="padding-top:5px;">
                              <input
                                type="checkbox"
                                id="footer_bg_color"
                                :true-value="1"
                                :false-value="0"
                                v-model="footer_prop.bg_color.show"
                              />
                              <label for="footer_bg_color"></label>
                            </div>
                            <!-- Color Picker -->
                            <input
                              type="text"
                              class="form-control"
                              :value="footer_prop.bg_color.value.hex"
                              disabled
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_9 }"
                              v-model="footer_prop.bg_color.value"
                            />
                            <b-input-group-text
                              @click="colorPickerActive.color_9 = !colorPickerActive.color_9"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': footer_prop.bg_color.value.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                         <b-form-group
                          horizontal
                          label="Font Color"
                          label-for="footer_font_color"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <input
                              type="text"
                              class="form-control"
                              :value="footer_prop.footer_font_color.hex"
                              disabled
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_3 }"
                              v-model="footer_prop.footer_font_color"
                            />
                            <b-input-group-text
                              style="padding:5px !important;"
                              @click="colorPickerActive.color_3 = !colorPickerActive.color_3"
                              slot="append"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': footer_prop.footer_font_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>

                        <!-- Organization Name Size -->
                        <b-form-group
                          horizontal
                          label="Font Size"
                          label-for="name_size"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group append="pt">
                            <b-form-input
                              name="footer_font_size"
                              :class="{'is-invalid':footer_has_error&&errors.has('footer_prop_tab.footer_font_size')}"
                              v-validate="'min_value:0|max_value:18'"
                              v-model="footer_prop.footer_font_size"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mb-4">
                          <div class="abc-checkbox">
                            <input
                              type="checkbox"
                              id="show_aging_detl"
                              :true-value="1"
                              :false-value="0"
                              v-model="footer_prop.show_aging_detl"
                            />
                            <label
                              for="show_aging_detl"
                              style="padding-top:2px;"
                            >Showing balance due aging details</label>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-tab>
              </b-tabs>
              <!-- Footer for Template settings -->
              <div style="position:fixed;bottom:0;width: 400px;" class="border-top">
                <b-button
                  @click="onSubmit()"
                  size="sm"
                  variant="primary"
                  class="btn-rounded mx-mar my-2"
                >Save</b-button>
              </div>
            </div>
          </div>
        </b-nav>
      </div>
      <div class="sidenave-main-content" style="margin-top:-17px;">
        <b-row class="px-3 border-bottom" style="height:42px;">
          <b-col cols="10" class="px-0">
            <b-button
              @click="preview()"
              size="sm"
              variant="light"
              class="mr-2 mt-1 text-link btn-rounded"
            >
              Preview
              <span>
                <i class="la la-eye la-lg"></i>
              </span>
            </b-button>
            <b-button
              v-b-modal.restoreSettings
              size="sm"
              variant="light"
              class="text-link btn-rounded mt-1"
            >Restore Default</b-button>
          </b-col>
          <b-col cols="2" class="text-right px-0">
            <a @click="redirectPage()" class="mr-2 text-right">
              <i class="la la-remove la-lg text-decoration-none mt-3"></i>
            </a>
          </b-col>
        </b-row>
        <div
          class="sidenav-view-block py-4"
          style="overflow-y: scroll;height: calc(100vh -112px);margin-left: -20px !important;margin-right: -20px !important;"
        >
          <CustomerStatement :list="list"></CustomerStatement>
        </div>
      </div>
    </div>
    <!-- modal for restore settings -->
    <b-modal
      id="restoreSettings"
      title="Restore Default Settings"
      cancel-title="No"
      cancel-variant="light"
      ok-title="Yes"
      @ok="backtodefault()"
    >
      <p>Are you sure you want to restore default settings?</p>
    </b-modal>
  </div>
</template>
 
 <script>
import Vue from "vue";
import { mapState } from "vuex";
import { Sketch } from "vue-color";
import bFormSlider from "vue-bootstrap-slider"; // Slider
import CustomerStatement from "@/components/Form/Settings/Print/Invoice/CustomerStatement";
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
Vue.use(bFormSlider); // Use silder
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import store from "@/store/index";
export default {
  props: ["id", "path"],
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    Sketch,
    CustomerStatement
  },
  data() {
    return {
      // color picker value for display
      colorPickerActive: {
        color_1: false,
        color_2: false,
        color_3: false,
        color_4: false,
        color_5: false,
        color_6: false,
        color_7: false,
        color_8: false,
        color_9: false,
        color_10:false,
        color_11:false,
         color_12:false
      },
      // Paper size options
      papersize: [
        {
          text: "A4",
          value: "0"
        },
        {
          text: "A5",
          value: "1"
        }
      ],
      // Orientation options
      orientation: [
        {
          text: "Portrait",
          value: "0"
        },
        {
          text: "Landscape",
          value: "1"
        }
      ],
      tabIndex: 0,
      itemTabIndex: 0,
      temp_has_error: false,
      header_has_error: false,
      item_label_has_error: false,
      item_layout_has_error: false,
      footer_has_error: false,
      isValidMarginWidth: "",
      isValidMarginHeight: "",
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },

  methods: {
    redirectPage() {
      if (this.path) {
        this.$router.push(this.path);
      } else {
        this.$router.push({
          name: "Templates",
          query: {
            stg_menu: "Customer Statement",
            template_group: "customer_statement"
          }
        });
      }
    },
    // preview print template
    preview() {
      this.validateForm().then(result => {
        if (
          result &&
          this.isValidMarginWidth == false &&
          this.isValidMarginHeight == false
        ) {
          EventBus.$emit("preview", this.list);
        }
      });
    },
    // validate paper size with margins
    validatePaperSize() {
      // Selected Paper width
      var paper_width =
        this.temp_prop.paper_size == 0
          ? this.temp_prop.orientation == 0
            ? 21
            : 29.7
          : this.temp_prop.orientation == 0
          ? 14.8
          : 21;
      // Selected paper height
      var paper_height =
        this.temp_prop.paper_size == 0
          ? this.temp_prop.orientation == 0
            ? 29.7
            : 21
          : this.temp_prop.orientation == 0
          ? 21
          : 14.8;
      // Total margins(left and right)
      var margin_width =
        this.temp_prop.margin_left / 0.3937 +
        this.temp_prop.margin_right / 0.3937;
      // Total margins (top and bottom)
      var margin_height =
        this.temp_prop.margin_top / 0.3937 +
        this.temp_prop.margin_bottom / 0.3937;
      // check valid margin width
      this.isValidMarginWidth = paper_width < margin_width;
      // check valid margin height
      this.isValidMarginHeight = paper_height < margin_height;
    },
    // validate form details
    async validateForm() {
      // Validate paper size with given margins

      this.validatePaperSize();
      var validated = false;
      // Validate Form template Form
      return new Promise((resolve, reject) => {
        this.$validator
          .validateAll("temp_prop_tab")
          .then(result => {
            if (
              result == false ||
              this.isValidMarginWidth ||
              this.isValidMarginHeight
            ) {
              this.tabIndex = 0;
              // Display margin validation error
              if (this.isValidMarginWidth || this.isValidMarginHeight) {
                // Display error notification
                window.Messenger().post({
                  extraClasses:
                    "messenger-fixed messenger-on-top messenger-on-center",
                  message: this.isValidMarginWidth
                    ? "The sum of left and right margins is more than the width of the selected paper"
                    : "The sum of top and bottom margins is more than the height of the selected paper",
                  type: "danger",
                  showCloseButton: true
                });
              }
              // Validation Error
              this.temp_has_error = true;
            } else {
              this.temp_has_error = false;
              // Validate Header tab Form
              this.$validator.validateAll("header_prop_tab").then(result => {
               
                if (result == false) {
                  this.tabIndex = 1;
                  this.header_has_error = true;
                } else {
                  this.header_has_error = false;
                  // Validate Iteam Tab Label form
                  this.$validator
                    .validateAll("item_label_prop_tab")
                    .then(result => {
                      if (result == false) {
                        this.tabIndex = 2;
                        this.itemTabIndex = 0;
                        this.item_label_has_error = true;
                      } else {
                        this.item_label_has_error = false;
                        // Validate Iteam Tab Layout form
                        this.$validator
                          .validateAll("item_layout_prop_tab")
                          .then(result => {
                            if (result == false) {
                              this.tabIndex = 2;
                              this.itemTabIndex = 1;
                              this.item_layout_has_error = true;
                            } else {
                              this.item_layout_has_error = false;
                              // Validate Total Tab Label form
                              // Validate Footer Tab form
                              this.$validator
                                .validateAll("footer_prop_tab")
                                .then(result => {
                                  if (result == false) {
                                    this.tabIndex = 4;
                                    this.footer_has_error = true;
                                  } else {
                                    this.footer_has_error = false;
                                    validated = true;
                                    resolve(validated);
                                  }
                                });
                            }
                          });
                      }
                    });
                }
              });
            }
          })
          .catch(() => {
            reject("false");
          });
      });
    },
    backtodefault() {
      this.list = JSON.parse(JSON.stringify(this.default_list));
      this.preview();
    },
    // Submit action
    onSubmit() {
      this.validateForm().then(result => {
        if (
          result &&
          this.isValidMarginWidth == false &&
          this.isValidMarginHeight == false
        ) {
          var data = JSON.stringify({
            list: {
              template_list: this.list
            }
          });
          this.$store
            .dispatch("settings/updateprintsettings", {
              id: this.$route.params.id,
              data: data
            })
            .then(() => {
              this.$router.push({
                name: "Templates",
                query: {
                  stg_menu: "Customer Statement",
                  template_group: "customer_statement"
                }
              });
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: "Customer Statement Template has been Saved ",
                type: "success",
                showCloseButton: true
              });
            });
        }
      });
    },
    // Find Logo height by width (height=width*1.22/2)
    findHieght(value) {
      this.header_prop.logo_height = value.newValue * (1.22 / 2);
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store
      .dispatch(
        "settings/fetchprintsettings",
        JSON.stringify({
          id: routeTo.params.id
        })
      )
      .then(() => {
        next();
      });
  },
  computed: {
    list: {
      get() {
        return this.$store.state.settings.template_list;
      },
      set(val) {
        this.$store.state.settings.template_list = val;
      }
    },

    ...mapState({
      default_list: state => state.settings.default_template_list,
      temp_prop: state => state.settings.template_list.temp_prop,
      header_prop: state => state.settings.template_list.header_prop,
      item_prop: state => state.settings.template_list.item_prop,
      total_prop: state => state.settings.template_list.total_prop,
      footer_prop: state => state.settings.template_list.footer_prop,
      menu_id: state => state.settings.template_list.menu_id
    })
  }
};
</script>
<style>
.print-temp .input-group input {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right: 0 !important;
}
.print-temp .input-group .input-group-append .input-group-text {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border: 1px solid #dadada !important;
  padding: 5px 9px;
}
.print-temp .custom-line-tab .nav-tabs > .nav-item .nav-link.active {
  border-bottom: 2px solid #0675b9 !important;
}
.print-temp .d-inline-block {
  margin: 6px;
}
.forms-elements .colorpicker-wrapper .colorpicker {
  top: 40px !important;
}
.vertical-sidenav.sidenav-container .sidenave-main-content {
  float: right;
  width: calc(100% - 400px);
}
</style>
